import { QUERY_PARAM_KEY_STORE_ID, QUERY_PARAM_KEY_TRANSACTION_ID } from '~constants/Constants';
import { TranslationRepository } from '~repositories/TranslationRepository';
import { UserRepository } from '~repositories/UserRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { validateStoreId } from '~utils/DropDownUtils';

export class StoreReceiptExtractedUseCase {
    private userRepository: UserRepository;
    private translationRepository: TranslationRepository;

    constructor() {
        this.userRepository = diContainer.get(serviceNames.userRepository);
        this.translationRepository = diContainer.get(serviceNames.translationRepository);
    }

    public async execute() {
        const { userFormStore } = this.userRepository;
        const urlParams = new URLSearchParams(window.location.search);
        const storeId = urlParams.get(QUERY_PARAM_KEY_STORE_ID);
        const transactionId = urlParams.get(QUERY_PARAM_KEY_TRANSACTION_ID);

        validateStoreId(storeId, this.translationRepository) &&
            userFormStore.setFieldValue('storeLocation', storeId as string);

        transactionId && userFormStore.setFieldValue('loyaltySignupPosTransId', transactionId);
    }
}
